export default __webpack_public_path__ + "static/media/ttb.ee98b07f.svg";